import { render, staticRenderFns } from "./SBOrderHistory.html?vue&type=template&id=a1598ce0&scoped=true&"
import script from "./SBOrderHistory.ts?vue&type=script&lang=ts&"
export * from "./SBOrderHistory.ts?vue&type=script&lang=ts&"
import style0 from "./SBOrderHistory.css?vue&type=style&index=0&id=a1598ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1598ce0",
  null
  
)

export default component.exports